import { render, staticRenderFns } from "./Repayment.vue?vue&type=template&id=0fafd890"
import script from "./Repayment.vue?vue&type=script&lang=js"
export * from "./Repayment.vue?vue&type=script&lang=js"
import style0 from "./Repayment.vue?vue&type=style&index=0&id=0fafd890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports